/**
 * The error codes of this area of the admin API and the auth routes (see
 * `./index.ts`): users, members, invitations and sign-in. One entry per
 * message the backend can send; the panel translates `errors.<code>`. The
 * auth routes (Better Auth's) send theirs in the body's `code`.
 */
export const ACCOUNT_ERROR_CODES = [
  'ALREADY_A_MEMBER_OF_THE_TENANT',
  'ALREADY_INVITED_TO_THE_TENANT',
  'ALREADY_MEMBER_OF_OR_INVITED_TO_THE_TENANT',
  'CANNOT_CHANGE_OWN_MEMBERSHIP',
  'INVALID_TENANT_SLUG',
  'INVITATION_LIMIT_REACHED',
  'INVITATION_NOT_OPEN',
  'INVITATION_CHANGE_NOT_ALLOWED',
  'INVITATION_CHANGED_MEANWHILE',
  'MEMBER_CHANGE_NOT_ALLOWED',
  'MEMBER_CHANGED_MEANWHILE',
  'NAME_LENGTH_INVALID',
  'NOT_SIGNED_IN',
  'ONLY_PLATFORM_ADMINS_BAN_USERS',
  'ONLY_PLATFORM_ADMINS_CHANGE_OWNER',
  'ONLY_PLATFORM_ADMINS_CHANGE_USERS',
  'ONLY_PLATFORM_ADMINS_CREATE_USERS',
  'ONLY_PLATFORM_ADMINS_INVITE_OWNER',
  'ONLY_PLATFORM_ADMINS_READ_USERS',
  'ONLY_PLATFORM_ADMINS_REVOKE_OWNER_INVITATION',
  'ONLY_PLATFORM_ADMINS_UNBAN_USERS',
  'OPEN_THE_LINK_OF_THE_INVITATION',
  'OWNER_STAYS_WITH_STAFF',
  'PLATFORM_ADMIN_CANNOT_LOWER_OWN_ROLE',
  'SIGN_UP_REQUIRES_INVITATION',
  'STAFF_CANNOT_BAN_THEMSELVES',
  'STAFF_ONLY_CHANGE_MEMBERS_OR_INVITATIONS',
  'STAFF_ONLY_CHANGE_TENANT',
  'STAFF_ONLY_MANAGE_MEMBERS_OF_ANY_TENANT',
  'TECHNICIAN_CANNOT_DO_THIS',
  'TENANT_FILTER_OPERATOR_NOT_SUPPORTED',
  'UNKNOWN_TENANT',
  'USER_EMAIL_TAKEN',
  'YOU_ARE_NOT_ALLOWED_TO_CANCEL_THIS_INVITATION',
] as const
